export default __webpack_public_path__ + "static/media/add-to-favourites-new.b548ee50.svg";